import React from 'react'

const SmallLoader = () => {
  return (
    <div className="w-5 h-5 border-2 border-primary border-l-transparent rounded-full animate-spin"></div>
  );
}

export default SmallLoader